import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CadastroLayoutComponent } from './containers/cadastro-layout/cadastro-layout.component';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { LayoutComponent } from './containers/default-layout/layout/layout.component';
import { RouteAuthGuard } from './shared/interceptors/routeAuthGuard';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: 'login',
        loadChildren: () =>
          import('./modules/login/login.module').then(m => m.LoginModule)
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' }
    ],
  },
  {
    path: 'welcome',
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/welcome/welcome.module').then(m => m.WelcomeModule)
      }
    ],
    canActivate: [],
  },
  {
    path: 'home',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/home/home.module').then(m => m.HomeModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'cadastro',
    component: CadastroLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/cadastro/cadastro.module').then(m => m.CadastroModule)
      }
    ],
  },
  {
    path: 'esqueci-senha',
    component: CadastroLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/esqueci-senha/esqueci-senha.module').then(m => m.EsqueciSenhaModule)
      }
    ],
  },
  {
    path: 'meus-dados',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/meus-dados/meus-dados.module').then(m => m.MeusDadosModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'fale-conosco',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/fale-conosco/fale-conosco.module').then(m => m.FaleConoscoModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'planos',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/planos/planos.module').then(m => m.PlanosModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'cotacao',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/cotacao/cotacao.module').then(m => m.CotacaoModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'operadoras',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/operadoras/operadoras.module').then(m => m.OperadorasModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'material',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/material/material.module').then(m => m.MaterialModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'notificacoes',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/notificacoes/notificacoes.module').then(m => m.NotificacoesModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'area-premiacoes',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/area-premiacoes/area-premiacoes.module').then(m => m.AreaPremiacoesModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'biblioteca-de-videos',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/biblioteca-de-videos/biblioteca-de-videos.module').then(m => m.BibliotecaDeVideosModule)
      }
    ],
    canActivate: [RouteAuthGuard],
  },
  {
    path: 'politica-de-privacidade',
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/politica-de-privacidade/politica-de-privacidade.module').then(m => m.PoliticaDePrivacidadeModule)
      }
    ],
  },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}

